import React from "react";

// Array of LinkedIn article links
const articleLinks = [
  "https://www.linkedin.com/pulse/how-migrate-data-from-one-sql-database-another-using-mysql-magezi-q8aqf",
  "https://www.linkedin.com/pulse/function-download-user-list-csv-nextreact-js-alaphat-magezi",
];

// Function to extract article metadata dynamically
function generateArticle(link) {
  const title = link
    .split("/pulse/")[1]
    .split("-")
    .join(" ")
    .replace(/^[a-z]/, (char) => char.toUpperCase());
  return {
    date: new Date().toDateString(),
    title,
    description: "Read this insightful article to learn more.",
    keywords: title.split(" "),
    style: `
      .article-content {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
      .randImage {
        align-self: center;
        outline: 2px solid red;
      }
    `,
    body: (
      <React.Fragment>
        <div className="article-content">
          <p>{title}</p>
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="randImage"
          >
            Read the article here.
          </a>
        </div>
      </React.Fragment>
    ),
  };
}

// Generate articles dynamically
const myArticles = articleLinks.map((link) => generateArticle(link));

export default myArticles;
